import { render, staticRenderFns } from "./button-list.vue?vue&type=template&id=03cdd756&scoped=true"
import script from "./button-list.vue?vue&type=script&lang=js"
export * from "./button-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03cdd756",
  null
  
)

export default component.exports